<template>
  <div class="contracts-filter">
    <div class="contracts-text-filter" style="margin-bottom: 8px;">
      <text-filter
        type="contracts"
        field="text_filter"
        label="Поиск по названию, шифру или номеру договора"
      />
    </div>
    <div class="filters-container">
      <select-filter
        type="contracts"
        field="manager"
        label="Менеджер"
        request="page/user?managers="
        :parse-value="getFullName"
        :filterable="true"
      />
      <select-filter
        type="contracts"
        field="field_manager"
        label="Полевой ГИП"
        request="page/field_manager?in_contracts="
        :parse-value="getFullName"
        :filterable="true"
      />
      <select-filter
        type="contracts"
        field="status"
        label="Статус"
        request="objectInfo/contract_statuses"
        :parse-value="({ name }) => name"
      />
      <sorting-control
        style="margin-left: 32px;"
        type="contracts"
        :values="sortingFields"
      />
    </div>
  </div>
</template>

<script>
import TextFilter from './helpers/text-filter'
import SelectFilter from './helpers/select-filter'
import SortingControl from './helpers/sorting-control'
import { getFullName } from '@/utils'

const sortingFields = [
  { field: 'date', name: 'Дата начала' },
  { field: 'status', name: 'Статус' },
  { field: 'code', name: 'Шифр' }
]

export default {
  components: {
    TextFilter,
    SelectFilter,
    SortingControl
  },
  data () {
    return {
      sortingFields,
      getFullName
    }
  }
}
</script>

<style></style>
